import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { RoleGuard } from '../../components/admin/RoleGuard';
import { authClient, clearAuthToken } from '../../lib/auth-client';

const ADMIN_LINKS = [
  { to: '/admin', label: 'Dashboard', end: true },
  { to: '/admin/orders', label: 'Orders' },
  { to: '/admin/consultations', label: 'Consultations' },
  { to: '/admin/customers', label: 'Customers' },
  { to: '/admin/services', label: 'Services' },
  { to: '/admin/payments', label: 'Payments' },
  { to: '/admin/content', label: 'Content' },
  { to: '/admin/leads', label: 'Leads' },
];

export default function AdminLayout() {
  const navigate = useNavigate();

  async function handleSignOut() {
    await authClient.signOut();
    clearAuthToken();
    navigate('/login');
  }

  return (
    <RoleGuard>
      <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-[220px_1fr]">
          <aside>
            <h2 className="font-display text-lg font-bold text-seal-blue">Admin Panel</h2>
            <nav className="mt-4 flex gap-2 overflow-x-auto md:flex-col md:overflow-visible">
              {ADMIN_LINKS.map((link) => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  end={link.end}
                  className={({ isActive }) =>
                    `whitespace-nowrap rounded px-3 py-2 text-sm font-medium transition-colors ${
                      isActive ? 'bg-seal-blue text-white' : 'text-ink/70 hover:bg-ink/5'
                    }`
                  }
                >
                  {link.label}
                </NavLink>
              ))}
              <button
                onClick={handleSignOut}
                className="mt-4 whitespace-nowrap rounded px-3 py-2 text-left text-sm font-medium text-red-600 transition-colors hover:bg-red-50"
              >
                Sign Out
              </button>
            </nav>
          </aside>
          <main>
            <Outlet />
          </main>
        </div>
      </div>
    </RoleGuard>
  );
}
